<template>
	<UiModalMobile
		v-model="modelValue"
		class="modal__mobile"
		:titleBtnSave="'Сохранить'"
		:isDontNeedCloseWhenSave="false"
		@save="saveHandler"
		height="calc(100% - 145px)"
		min-height-body="unset"
		:is-loading-btn-save="props.isLoading"
		:is-need-cancel-btn="false"
		:isNeedBtnSave="false"
		:isNeedFixedModalWithIfElseBlock="false"
		:z-index="10000"
	>
		<TypographyKTypographyBody2
			color="var(--color_font_black_wite)"
			font-type="bold"
			class="header__title"
		>
			{{ getTitle }}
		</TypographyKTypographyBody2>
		<CommonInputSpecialInput
			v-model="payload.searchInput"
			:readonly="false"
			:isNeedChangeBtn="true"
			:isNeedAlwaysVisibleInput="true"
			btnTitle="Найти"
			:isDisabled="false"
			placeholder="Наименование города"
			@clickBtn="searchSender"
			class="content-wrapper"
			:isLoading="loading.searchSender"
			:suggestions="cityList"
			:isVisibleSuggestionsDefault="true"
			@chooseSuggestion="chooseCity"
		>
			<template #left-icon>
				<UiIcon
					name="search"
					width="20px"
					@click="searchSender"
				/>
			</template>
		</CommonInputSpecialInput>
		<template #custom-actions> </template>
	</UiModalMobile>
</template>

<script setup lang="ts">
	import { useStorekeeperStore } from '~/store/storekeeper.store';
	import type { IStorekeeperCity } from '~~/shared/interfaces/storekeeper';
	import { TClientType, type IClient } from '~~/shared/interfaces/storekeeperClient';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['save', 'chooseCity']);
	const modelValue = defineModel('modelValue', { required: true, type: Boolean });
	const props = withDefaults(
		defineProps<{
			isLoading?: boolean;
			searchInputDefault?: string;
			currentCargo: any;
			typeClients: TClientType;
		}>(),
		{
			searchInputDefault: ''
		}
	);

	const storekeeperStore = useStorekeeperStore();
	const cityList = ref<IStorekeeperCity[]>([]);

	const getTitle = computed(() => {
		return 'Найти город';
	});

	const getCurrentClient = computed(() => {
		return props.currentCargo?.cityId;
	});

	const loading = reactive({
		searchSender: false,
		saveNewClient: false
	});
	const payload = ref({
		searchInput: props.searchInputDefault
	});

	const chooseCity = async (city: any) => {
		emits('chooseCity', { id: city?.key, name: city?.value });

		modelValue.value = false;
	};

	const searchSender = async () => {
		loading.searchSender = true;
		const response = await storekeeperStore.getStorekeeperCitiesLookups({ filter: payload.value.searchInput });

		if (response.status === 'success') {
			cityList.value = response.data || [];
		}

		loading.searchSender = false;
	};

	const saveHandler = async (status: string) => {};
</script>

<style scoped lang="scss">
	.header__title {
		margin-bottom: 6px;
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		height: calc(100% - 30px) !important;
	}
	.content {
		display: flex;
		overflow: auto;
		margin-top: 1rem;
		height: calc(100% - 100px);
		margin-right: -5px;
		padding-right: 5px;

		.scroller {
			display: flex;
			flex-direction: column;
			gap: 8px;
			height: calc(100%);
			width: 100%;
			margin-right: -5px;
			padding-right: 5px;
		}

		.scroller :deep(.vue-recycle-scroller__item-view) {
			will-change: transform;
		}

		.client {
			padding-bottom: 8px;

			&__card {
				background-color: var(--white);
				border-radius: 12px;
				padding: 12px 12px;
			}

			&.--active {
				.client__card {
					border: 1px solid var(--red);
				}
			}

			.client__body {
				background-color: #eaedf5;
				padding: 10px;
				border-radius: 10px;
				margin-top: 6px;

				.text-block {
					display: flex;
					flex-direction: column;
					gap: 3px;

					.title {
						font-weight: 600;
					}

					.subtitle {
					}
				}
			}

			.choose-btn {
				margin-top: 8px;
				width: 100%;
			}
		}
	}

	.actions {
		.btn {
			width: 100%;
		}
	}
</style>
